import { render, staticRenderFns } from "./followListDialog.vue?vue&type=template&id=f1830d52&scoped=true"
import script from "./followListDialog.vue?vue&type=script&lang=js"
export * from "./followListDialog.vue?vue&type=script&lang=js"
import style0 from "./followListDialog.vue?vue&type=style&index=0&id=f1830d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1830d52",
  null
  
)

export default component.exports